import apiFetch from '../apiFetch'

export default function ({idAnalisis,idVerraco}) {
  return apiFetch({
    endPoint: `Analisis/getUltimasExtraccionesVerraco?idAnalisis=${idAnalisis}&idVerraco=${idVerraco}`,
    method: 'GET', body: null, token: null
  })
}